import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './store/store';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import { resetAndInitializeData } from './services/dataService';

// Reset and initialize data with consistent IDs
resetAndInitializeData();
console.log("Data reset and initialized with consistent IDs");

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
); 